module.exports = __webpack_public_path__ + "img/JJ-installation.5263f751.png";